import React from "react";
import { Card, CardContent } from "../ui/card";

const StatCard = ({ title, value, icon: Icon, color = "text-foreground", bgColor = "bg-theme-surface", subtitle, "data-testid": dataTestId }) => (
  <Card className="glass-card border-theme" data-testid={dataTestId}>
    <CardContent className="p-4">
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-lg ${bgColor} flex items-center justify-center`}>
          <Icon className={`w-5 h-5 ${color}`} />
        </div>
        <div className="min-w-0">
          <p className="text-xs text-muted-foreground truncate">{title}</p>
          <p className={`text-lg font-bold ${color}`}>{value}</p>
          {subtitle && <p className="text-[10px] text-muted-foreground/70 mt-0.5 truncate">{subtitle}</p>}
        </div>
      </div>
    </CardContent>
  </Card>
);

export default StatCard;
